import { StepProps } from "antd/lib";
import { FC, useMemo } from "react";
import {
    SubtaskUpdateMarketInfo,
    TaskUpdateMarketInfoPayload,
} from "tm-shared/types";

import { isSubtaskCompleted } from "@/utils/business/isSubtaskCompleted";

import { StyledSteps, StyledStepsContainer } from "./Styled";

interface StepsSectionProps {
    subtasks: SubtaskUpdateMarketInfo[];
    currentStep: number;
    onStepChange: (stepKey: number) => void;
    payloadMapBySubtaskId: TaskUpdateMarketInfoPayload | null;
}

export const StepsSection: FC<StepsSectionProps> = ({
    subtasks,
    currentStep,
    onStepChange,
    payloadMapBySubtaskId,
}) => {
    const steps: StepProps[] = useMemo(() => {
        return subtasks.map((s, index) => {
            const { subtaskId } = s;

            let status = "wait";

            const currentPayload = payloadMapBySubtaskId?.[subtaskId];

            if (!!currentPayload && isSubtaskCompleted(currentPayload)) {
                status = "finish";
            }

            if (index === currentStep) {
                status = "process";
            }

            return {
                key: subtaskId,
                status: status as StepProps["status"],
            };
        });
    }, [subtasks, currentStep]);

    return (
        <StyledStepsContainer>
            <StyledSteps
                direction="horizontal"
                size="small"
                responsive={false}
                current={currentStep}
                onChange={onStepChange}
                items={steps}
            />
        </StyledStepsContainer>
    );
};
